import { List } from "antd";
import React from "react";
import "./css/index.css";
import { MyListItem } from "./MyListItem";

export const MyList = ({ list = [], type, activeId }) => {
  return (
    <List
      className="my-list-for-materials-and-work"
      dataSource={list}
      renderItem={(item) => (
        <MyListItem item={item} type={type} activeId={activeId} />
      )}
    />
  );
};
